import { render, staticRenderFns } from "./InviaStima.vue?vue&type=template&id=74ee862e&scoped=true"
import script from "./InviaStima.vue?vue&type=script&lang=js"
export * from "./InviaStima.vue?vue&type=script&lang=js"
import style0 from "./InviaStima.vue?vue&type=style&index=0&id=74ee862e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee862e",
  null
  
)

export default component.exports